import * as c from '../../constants/simulation';

export const defaultState = {
  loading: false,
  startingCompetition: false,
  slot1: null,
  slot2: null,
  competitionTitle: '',
  connectedSchools: 0,
  competingSchools: 0,
  sortDir: 1,
  sortField: 'name',
  designList: [],
  designGrouping: c.SIMULATION_GROUPING_GROUP,
  designFilter: c.SIMULATION_FILTER_STAGED,
  topCount: 10,
  view: c.SIMULATION_VIEW_SETUP,
  results: null,
};

const simulation = (state = defaultState, action) => {
  switch (action.type) {
    case c.SIMULATION_SET_VIEW:
      return { ...state, view: action.view };
    case c.SIMULATION_SET_SORT:
      let sortDir =
        action.sortDir !== undefined ? action.sortDir : state.sortDir;
      let sortField =
        action.sortField !== undefined ? action.sortField : state.sortField;
      return { ...state, sortDir, sortField };
    case c.SIMULATION_SET_SLOT:
      if (action.slot === 1) {
        return { ...state, slot1: { id: action.designId, name: action.name } };
      } else if (action.slot === 2) {
        return { ...state, slot2: { id: action.designId, name: action.name } };
      } else {
        return state;
      }
    case c.SIMULATION_SET_GROUPING:
      return { ...state, designGrouping: action.grouping };
    case c.SIMULATION_SET_FILTER:
      return { ...state, designFilter: action.filter };
    case c.SIMULATION_SET_TOP_COUNT:
      return { ...state, topCount: action.count };
    case c.SIMULATION_LOAD_CONTENDERS:
      return { ...state, loading: true };
    case c.SIMULATION_LOAD_CONTENDERS_SUCCESS:
      return { ...state, designList: action.result, loading: false };
    case c.SIMULATION_LOAD_CONTENDERS_FAILURE:
      return { ...state, loading: false };
    case c.SIMULATION_START:
      return { ...state, startingCompetition: true, loading: true };
    case c.SIMULATION_START_SUCCESS:
      return {
        ...state,
        startingCompetition: false,
        view: action.result.skipUnity? c.SIMULATION_VIEW_FINISHED : c.SIMULATION_VIEW_INPROGRESS,
        results: action.result.results,
        loading: false,
      };
    case c.SIMULATION_START_FAILURE:
      return { ...state, startingCompetition: false, loading: false };
    case c.SIMULATION_FINISH:
      return { ...state, view: c.SIMULATION_VIEW_FINISHED };
    case c.SIMULATION_RESET:
      return {
        ...state,
        view: c.SIMULATION_VIEW_SETUP,
        slot1: null,
        slot2: null,
        results: null,
      };
    default:
      return state;
  }
};

export default simulation;
